import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { useGetUser } from '../../../hooks/useGetUser';
import { Select, MenuItem, InputLabel, FormControlLabel, Radio, RadioGroup, FormLabel, FormGroup } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import moment from "moment";
import "moment/locale/pt-br";
import FormData from 'form-data';
import styles from './styles.module.scss';
import ButtonsImagesCampain from '../../../components/ButtonsImagesCampain';
import Paginacao from '../../../components/Paginacao';
import { getExisteOrdemExibicao, getObterOrdemExibicao, postVitrineBV, putVitrineBV, getParceiros, getFilial, getVitrineBVById, postEncerrarCampanha, getParticipantesList, getClassificacaoList, getRegionalList, getParticipantesPorFiltroList } from '../../../services/api-auto';
import BeneficioParceiroCard from '../../../components/BeneficioParceiroCard';
import { useDispatch } from "react-redux";
import { 
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
    showMsgC,
} from '../../../store/actions/snackbarActions.js';
import { useDebounce } from '../../../hooks/debounceHook';
import ModalLoading from '../../../components/ModalLoading';

const dataInit = {
    idVitrineBV: null,
    titulo: "",
    periodoInicial: null,
    periodoFinal: null,
    periodoAtividade: 0,
    tipo: 0,
    status: 1,
    ordemExibicao: 1,
    lojasParticipantes: [
        {
            idParticipanteVitrineBV: null,
            participanteId: null,
            idVitrineBV: null,
            classificacao: "",
            regional: "",
            filial: "",
            loja: "",
            participanteNome: ""
        }
    ],
    linkBeneficio: "",
    aceitaAcompanhante: false,
    quantidade: null,
    conteudo: "",
    linkDestaqueDesktop: "",
    linkDestaqueMobile: "",
    linkConteudoDesktop: "",
    linkConteudoMobile: ""
}

const DetalheVitrine = () => {
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const history = useHistory();
    const [data, setData] = useState(dataInit);
    const [regionais, setRegionais] = useState([]);
    const [classificacoes, setClassificacoes] = useState([]);
    const [classificacaoSelecionado, setClassificacaoSelecionado] = useState('todos');
    const [regionalSelecionado, setRegionalSelecionado] = useState('todos');
    const [participantes, setParticipantes] = useState([]);
    const [filial, setFilial] = useState([]);
    const [filialSelecionado, setFilialSelecionado] = useState('todos');
    const [parceiros, setParceiros] = useState([]);
    const [parceiroSelecionado, setParceiroSelecionado] = useState('todos');
    const [participanteSelecionado, setParticipanteSelecionado] = useState('todos');
    const [indicarErros, setIndicarErros] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [search, setSearch] = useState('')
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);

    const validarForm = () => {

        let valid = true;
        let msg = "";

        if(!data.titulo){
            msg += `O campo Título é obrigatório. `; 
            valid = false; 
            showMsgW(msg)
        }
        if(!data.lojasParticipantes.length){
            msg += "Você deve inserir ao menos um participante. "; 
            valid = false; 
            showMsgW(msg)
        }
        if(data.periodoAtividade === '1' && (!data.periodoInicial || !data.periodoFinal)){
            msg += "As datas são obrigatórias quando o período de atividade for determinado. "; 
            valid = false; 
            showMsgW(msg)
        }
        if(!data.conteudo){
            msg += "O campo conteúdo é obrigatório. "; 
            valid = false; 
            showMsgW(msg)
        }
        if(data.tipo === '2' && !data.linkBeneficio){
            msg += "O campo Link é obrigatório quando selecionado o tipo brindes e premiações. "; 
            valid = false; 
            showMsgW(msg)
        }
        if(data.tipo === '1' && data.aceitaAcompanhante && (data.quantidade === 0 || data.quantidade === null)){
            msg += "A quantidade de acompanhantes deve ser maior que zero quando marcado aceita acompanhantes. "; 
            valid = false; 
            showMsgW(msg)
        }
        if( !data.linkConteudoDesktop  && !data.linkConteudoMobile ){
            msg += "Você deve carregar as imagens do conteúdo. "; 
            valid = false; 
            showMsgW(msg)
        }
        if( !data.linkDestaqueDesktop  && !data.linkDestaqueMobile ){
            msg += "Você deve carregar as imagens do destaque."; 
            valid = false; 
            showMsgW(msg)
        }

        if(msg) 
            showMsgW(msg)

        setIndicarErros(!valid);
        return valid;
    }

    const getVitrineIfEdit = async (id) => {

        if(id){
            setModalLoading(true)
            try{
                const info = await getVitrineBVById(id);
                setData(info.data);
                var totalPage = info.data.lojasParticipantes.length === 0 ? 1 : info.data.lojasParticipantes.length / 12;
                setMaxPage(Math.ceil(totalPage) + 1);

            } catch(e){
                showMsgW('Não foi possível carregar os dados')
            }
            setModalLoading(false)
        } else {
            const ordem = await getObterOrdemExibicao();
            setData({ ...data, ordemExibicao: ordem.data })
        }
    }

    function paginate (array, page_number, page_size = 12) {
        return array.slice((page_number - 1) * page_size, page_number * page_size);
    }

    const adicionarParceiro = async () => {
        setModalLoading(true);
        var objFiltro = {
            Classificacao : classificacaoSelecionado.toString(),
            Regional : regionalSelecionado,
            Filial : filialSelecionado,
            RazaoSocial : parceiroSelecionado,
            ParticipanteId : participanteSelecionado
        };

        var response = await  getParticipantesPorFiltroList(objFiltro);
        
        if(response.data.length === 0) {
            showMsgW("O filtro informado não retornou dados!");
        }

        var objEdicao = data;
        var obj = response.data.filter(loja => !objEdicao.lojasParticipantes.some(lojaEdicao => lojaEdicao.participanteId === loja.participanteId));
        obj = [...obj, ...data.lojasParticipantes]
        var totalPage = obj.length === 0 ? 1 : obj.length / 12;
        setMaxPage(Math.ceil(totalPage) + 1);
        setData({ ...data, lojasParticipantes: obj });
        setModalLoading(false);
    }

    const deletarParceiro = ( participanteId ) => {

        if(window.confirm("Deseja realmente excluir o participante selecionado?")) {
            var obj = data.lojasParticipantes.filter(loja => loja.participanteId !== participanteId);
            var totalPage = obj.length === 0 ? 1 : obj.length / 12;
            setMaxPage(Math.ceil(totalPage) + 1);
            setData({ ...data, lojasParticipantes: obj });
        }

    }

    const validarOrdemExibicao = (ordem) => {

        // var existe = getExisteOrdemExibicao(ordem);

        // if(existe.data) {
        //     showMsgW("Já existe a ordem de exibição informada");
        // } else {
        //     setData({ ...data, ordemExibicao:ordem})
        // }
        setData({ ...data, ordemExibicao:ordem})
    }

    const carregarFilial = async () =>{
        const info = await getFilial(regionalSelecionado, classificacaoSelecionado.toString())
        setFilial(info);
    }

    const carregarParceiro = async () =>{
        const info = await getParceiros(regionalSelecionado, filialSelecionado, classificacaoSelecionado.toString())
        setParceiros(info);
    }

    const enviar = async() => {
        setIndicarErros(false)
        if(validarForm()) {
            let formdata = data;

            formdata.aceitaAcompanhante = formdata.tipo !== 1 ? false : formdata.aceitaAcompanhante;
            formdata.periodoInicial = formdata.periodoAtividade === 0 ? null : formdata.periodoInicial;
            formdata.periodoFinal = formdata.periodoAtividade === 0 ? null : formdata.periodoFinal;
            formdata.quantidade = formdata.aceitaAcompanhante ? formdata.quantidade : 0;
            formdata.linkBeneficio = formdata.tipo !== 2 ? "" : formdata.linkBeneficio;
            
            if( data.idVitrineBV !== null ) {
                setModalLoading(true)
                try{
                    let info = await putVitrineBV(formdata);
                    showMsgS("Dados salvos com sucesso!")
                    setTimeout(()=>{
                        history.push('/vitrine')
                    }, 2000)
                } catch(e){
                    showMsgE("Ocorreu um erro ao salvar os dados")
                }
                setModalLoading(false)
            } else {
                setModalLoading(true)
                try{
                    let info = await postVitrineBV(formdata);
                    showMsgS("Dados salvos com sucesso!")
                    setTimeout(()=>{
                        history.push('/vitrine')
                    }, 2000)
                } catch(e) {
                    showMsgE("Ocorreu um erro ao salvar os dados")
                }
                setModalLoading(false)
            }
        }
    }

    const obterRegionais = async () => {
        var response = await getRegionalList(classificacaoSelecionado);
        if(response)
            setRegionais(response);
    }

    const obterClassificacao = async () => {
        var response = await getClassificacaoList();
        if(response)
            setClassificacoes(response);
    }

    const ObterParticipantes = async () => {
        var participantes = await getParticipantesList(parceiroSelecionado);
        setParticipantes(participantes.data);
    }

    useEffect( () => {
        const id = new URLSearchParams(history.location.search).get("IdVitrineBV");
        getVitrineIfEdit(id);
    },[])

    useEffect(() => {
        obterClassificacao();
    }, [])

    useEffect(() => {
        if(classificacaoSelecionado !== 'todos')
            obterRegionais(classificacaoSelecionado);
        else {
            setRegionais([]);
            setFilial([]);
            setParceiros([]);
            setParticipantes([]);
            setRegionalSelecionado('todos');
            setFilialSelecionado('todos');
            setParceiroSelecionado('todos');
            setParticipanteSelecionado('todos');
        }
    }, [classificacaoSelecionado])

    useEffect(() => {
        if(parceiroSelecionado !== 'todos')
            ObterParticipantes();
        else {
            setParticipantes([]);
            setParticipanteSelecionado('todos');
        }
    }, [parceiroSelecionado])

    useEffect( () => {
        if(regionalSelecionado) {
            carregarFilial();
        } else {
            setFilial([]);
            setParceiros([]);
            setParticipantes([]);
            setFilialSelecionado('todos');
            setParceiroSelecionado('todos');
            setParticipanteSelecionado('todos');
        }
    },[regionalSelecionado])

    useEffect( () => {
        if(filialSelecionado) {
            carregarParceiro();
        } else {
            setParceiros([]);
            setParticipantes([]);
            setParceiroSelecionado('todos');
            setParticipanteSelecionado('todos');
        }
    },[filialSelecionado])

    const user = useGetUser();

    return (
        <>

            {( user.perfilAcesso === 'Master' ) && (
                <>
                    <div className={styles.wrapper}>
                        <div className={styles.title}>
                            Vitrine BV - Detalhe
                            <button className={styles.backButton} onClick={() => {history.goBack()}}>
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                        </div>

                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card} style={{padding: '16px 16px 6px 16px'}}>
                                    <FormControl>
                                        <TextField  type="text"  size="small"
                                            onChange={(e) => {setData({ ...data, titulo:e.target.value})}}
                                            label="Título"
                                            value={data.titulo}
                                            variant="filled"
                                            error={indicarErros && !data.titulo ? true : false}
                                            className="customFilledInput"
                                        />
                                    </FormControl>
                                    <FormControl>
                                        <InputLabel id="select-status-label">
                                            Status
                                        </InputLabel>
                                        <Select
                                            labelId='select-status-label'
                                            label="Status"
                                            onChange={(e)=>{setData({...data, status: e.target.value})}}
                                            value={data.status}
                                            variant="filled"
                                            className="customFilledInput"
                                        >
                                            <MenuItem value={0}>Inativo</MenuItem>
                                            <MenuItem value={1}>Ativo</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormControl>
                                        <TextField  type="text"  size="small" 
                                            onChange={(e) => {validarOrdemExibicao(e.target.value)}}
                                            label="Ordem de exibição"
                                            value={data.ordemExibicao}
                                            variant="filled"
                                            multiline
                                            className={`customFilledInput`}
                                            error={indicarErros && !data.ordemExibicao ? true : false}
                                            disabled
                                        />
                                    </FormControl>
                                    <FormControl className={styles.halfRadio}>
                                        <FormLabel id="demo-row-radio-buttons-group-label">Período de atividade</FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            defaultValue={0}
                                            value={data.periodoAtividade}
                                            className={styles.tipoBeneficio}
                                            style={{flexWrap: "nowrap"}}
                                            onChange={(e) => {setData({ ...data, periodoAtividade: parseInt(e.target.value) }) }}
                                        >
                                            <FormControlLabel value={0} control={<Radio style={{color: "#5CCBE1"}}/>} label="Indeterminado" />
                                            <FormControlLabel value={1} control={<Radio style={{color: "#5CCBE1"}}/>} label="Determinado" />
                                        </RadioGroup>
                                    </FormControl>
                                    <FormControl className={styles.halfRadio}>
                                        <FormLabel id="demo-row-radio-buttons-group-label">Tipo de benefício</FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            className={styles.tipoBeneficio}
                                            value={data.tipo}
                                            defaultValue={0}
                                            onChange={(e) => {setData({ ...data, tipo: parseInt(e.target.value) })}}
                                        >
                                            <FormControlLabel value={0} control={<Radio style={{color: "#5CCBE1"}} />} label="Informativo" />
                                            <FormControlLabel value={1} control={<Radio style={{color: "#5CCBE1"}}/>} label="Evento" />
                                            <FormControlLabel value={2} control={<Radio style={{color: "#5CCBE1"}}/>} label="Brindes e premiações" />
                                        </RadioGroup>
                                    </FormControl>
                                    
                                    <FormControl className={styles.data}>
                                        <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                label="De"
                                                format="DD/MM/yyyy"
                                                value={data.periodoInicial}
                                                InputAdornmentProps={{ position: "start" }}
                                                onChange={novaData => { setData({ ...data, periodoInicial:novaData}) }}
                                                className="customFilledInput"
                                                error={indicarErros && !data.periodoInicial ? true : false}
                                                hidden={data.periodoAtividade === 0}
                                                invalidDateMessage="Data em formato inválido."
                                                maxDateMessage="Data não deve ser maior que a data máxima."
                                                minDateMessage="Data não deve ser menor que a data mínima."
                                            />
                                        </MuiPickersUtilsProvider>
                                    </FormControl>
                                    <FormControl className={styles.data}>
                                        <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                label="Até"
                                                format="DD/MM/yyyy"
                                                value={data.periodoFinal}
                                                InputAdornmentProps={{ position: "start" }}
                                                onChange={novaData => { setData({ ...data, periodoFinal:novaData}) }}
                                                className="customFilledInput"
                                                error={indicarErros && !data.periodoFinal ? true : false}
                                                hidden={data.periodoAtividade === 0}
                                                invalidDateMessage="Data em formato inválido."
                                                maxDateMessage="Data não deve ser maior que a data máxima."
                                                minDateMessage="Data não deve ser menor que a data mínima."
                                            />
                                        </MuiPickersUtilsProvider>
                                    </FormControl>
                                </div>
                            </div>
                        </div>

                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card}>

                                    <div className={styles.topSpacing}>
                                        <div className={styles.subtitleConfiguracao}>
                                            Público-alvo
                                        </div>
                                        <FormControl>
                                            <InputLabel id="select-classificacao-label">
                                                Classificação
                                            </InputLabel>
                                            <Select
                                                labelId='select-classificacao-label'
                                                label="Classificação"
                                                onChange={(e)=>{ setClassificacaoSelecionado( e.target.value ) }}
                                                value={classificacaoSelecionado}
                                                variant="filled"
                                                className="customFilledInput"
                                            >
                                                <MenuItem value="todos">Todos</MenuItem>
                                                {classificacoes.map( (c) => {
                                                    return(
                                                        <MenuItem value={c.classificacaoId} key={c.classificacaoId}>{c.descricao}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div>
                                        <FormControl>
                                            <InputLabel id="select-regional-label">
                                                Regional
                                            </InputLabel>
                                            <Select
                                                labelId='select-regional-label'
                                                label="Regional"
                                                onChange={(e)=>{ setRegionalSelecionado( e.target.value ) }}
                                                value={regionalSelecionado}
                                                variant="filled"
                                                className="customFilledInput"
                                            >
                                                <MenuItem value="todos">Todos</MenuItem>
                                                {regionais.map( (regiao) => {
                                                    return(
                                                        <MenuItem value={regiao} key={regiao}>{regiao}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                        <FormControl>
                                            <InputLabel id="select-filial-label">
                                            Filial
                                            </InputLabel>
                                            <Select
                                                labelId='select-filial-label'
                                                label="Filial"
                                                onChange={(e)=>{ setFilialSelecionado( e.target.value )}}
                                                value={filialSelecionado}
                                                variant="filled"
                                                className="customFilledInput"
                                            >
                                                <MenuItem value="todos">Todos</MenuItem>
                                                {filial.map( (info) => {
                                                    return(
                                                        <MenuItem value={info} key={info}>{info}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                        <FormControl>
                                            <InputLabel id="select-loja-label">
                                                Loja
                                            </InputLabel>
                                            <Select
                                                labelId='select-loja-label'
                                                label="Loja"
                                                onChange={(e) => { setParceiroSelecionado( e.target.value ) }}
                                                value={parceiroSelecionado}
                                                variant="filled"
                                                className="customFilledInput"
                                            >
                                                <MenuItem value="todos">Todos</MenuItem>
                                                {parceiros.map( (parceiro) => {
                                                    return (
                                                        <MenuItem value={parceiro.idParceiro} key={parceiro.idParceiro}>
                                                            {parceiro.nomeParceiro}
                                                        </MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                        <FormControl>
                                            <InputLabel id="select-participante-label">
                                                Participante
                                            </InputLabel>
                                            <Select
                                                labelId='select-participante-label'
                                                label="Participante"
                                                onChange={(e)=>{ setParticipanteSelecionado( e.target.value )} }
                                                value={participanteSelecionado}
                                                variant="filled"
                                                className="customFilledInput"
                                            >
                                                <MenuItem value="todos">Todos</MenuItem>
                                                {participantes.map( (p) => {
                                                    return (
                                                        <MenuItem value={p.participanteId} key={p.participanteId}>
                                                            {p.nomeParticipante}
                                                        </MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                        <button className={styles.salvar} onClick={adicionarParceiro}>
                                            Adicionar
                                        </button>
                                        { data.lojasParticipantes?.length > 0 && data.lojasParticipantes.some(l => l.participanteId !== null) &&
                                            <>
                                                <div className={styles.addLojasWrapper}>
                                                    {
                                                        Boolean(data.lojasParticipantes.length) ?
                                                        paginate(data.lojasParticipantes, page).filter(l => l.participanteId !== null).map( (loja) => {
                                                            return(
                                                                <BeneficioParceiroCard parceiro={loja} key={loja.idParticipanteVitrineBV} remover={deletarParceiro}/>
                                                            )
                                                        }) :
                                                        (
                                                            <div>
                                                                Nenhum parceiro nesta lista
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                { maxPage > 1 && (
                                                    <Paginacao maxPage={maxPage} page={page} setPage={setPage}/>
                                                )}
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card} style={{padding: '16px 16px 6px 16px'}}>
                                    <FormControl hidden={data.tipo !== 2}>
                                        <TextField  type="text"  size="small"
                                            onChange={(e) => {setData({ ...data, linkBeneficio:e.target.value})}}
                                            label="Link"
                                            value={data.linkBeneficio}
                                            variant="filled"
                                            error={indicarErros && !data.linkBeneficio ? true : false}
                                            className="customFilledInput"
                                        />
                                    </FormControl>
                                    <FormControl className={styles.halfRadio} hidden={data.tipo !== 1}>
                                        <FormLabel id="demo-row-radio-buttons-group-label">Aceita acompanhantes?</FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            defaultValue={false}
                                            value={data.aceitaAcompanhante}
                                            style={{flexWrap: "nowrap"}}
                                            onChange={(e) => {setData({ ...data, aceitaAcompanhante: (e.target.value === 'true') })}}
                                        >
                                            <FormControlLabel value={true} control={<Radio style={{color: "#5CCBE1"}}/>} label="Sim" />
                                            <FormControlLabel value={false} control={<Radio style={{color: "#5CCBE1"}}/>} label="Não" />
                                        </RadioGroup>
                                    </FormControl>
                                    <FormControl hidden={data.tipo !== 1}>
                                        <TextField  type="numeric"  size="small"
                                            onChange={(e) => {setData({ ...data, quantidade: parseInt(e.target.value)})}}
                                            label="Quantidade"
                                            value={data.quantidade}
                                            variant="filled"
                                            error={indicarErros && !data.quantidade ? true : false}
                                            className="customFilledInput"
                                            disabled={!data.aceitaAcompanhante}
                                        />
                                    </FormControl>
                                    <FormControl>
                                        <TextField
                                            onChange={(e) => {setData({ ...data, conteudo:e.target.value})}}
                                            label="Conteúdo"
                                            value={data.conteudo}
                                            multiline
                                            rows={10}
                                            variant="filled"
                                            className={`customFilledInput`}
                                            error={indicarErros && !data.conteudo ? true : false}
                                        />
                                    </FormControl>

                                </div>
                            </div>
                        </div>

                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card}>
                                    <div className={styles.subtitle}>
                                        Imagens
                                    </div>
                                    <div className={styles.divImageList}>
                                        <FormGroup>
                                            <ButtonsImagesCampain
                                                texto = 'Banner que será exibido na área de destaque.'
                                                width = '1200'
                                                height = '600'
                                                widthMM = '317.5'
                                                heightMM = '158.75'
                                                image={data.linkDestaqueDesktop}
                                                changeImage={(file)=>{setData({...data, 'linkDestaqueDesktop':file})}}
                                                error={indicarErros && !data.linkDestaqueDesktop ? true : false}
                                                obterLink={true}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <ButtonsImagesCampain
                                                texto = 'Banner que será exibido no detalhe do benefício.'
                                                width = '400'
                                                height = '400'
                                                widthMM = '132.29'
                                                heightMM = '132.29'
                                                image={data.linkConteudoMobile}
                                                changeImage={(file)=>{setData({...data, 'linkConteudoMobile':file})}}
                                                error={indicarErros && !data.linkConteudoMobile ? true : false}
                                                obterLink={true}
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card}>
                                    <div className={styles.subtitle}>
                                        Ações
                                    </div>
                                    <button className={styles.encerrar} onClick={() => {if(window.confirm("Deseja cancelar esta edição? Todos os dados não salvos serão perdidos.")) { history.push("/vitrine"); }}}>
                                        Cancelar
                                    </button>
                                    <button className={styles.salvar} onClick={enviar}>
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <ModalLoading
                        open={modalLoading} 
                        size="lg"
                    />
                
            </>    
        )}

        </>
    );
}

export default DetalheVitrine;